import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Wrapper from './Wrapper';

const Content = ({ children, className, css }) => {
  const contentCls = cn('cr-layout__content', className);
  return (
    <Wrapper className={contentCls} css={css}>
      <div className="cr-width-full">{children}</div>
    </Wrapper>
  );
};

Content.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  css: PropTypes.shape(),
};

export default Content;
